var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style[`cc-side-effect-consult`]},[_c('div',{class:_vm.$style[`cc-side-effect-consult-wrap`]},[(_vm.openChatRoom)?_c('EffectChatRoom'):_c('EffectConsultVendor')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }